import client from '../client';
import {
  CuttingOrdersResponse,
  PrintTravelerRequest,
  ActionHistoryItem
} from '../../../../shared/types';

export const cuttingOrderService = {
  /**
   * Get all orders in cutting station
   */
  getCuttingOrders: async (): Promise<CuttingOrdersResponse> => {
    const response = await client.get<CuttingOrdersResponse>('/cutting-orders');
    return response.data;
  },

  /**
   * Get cutting order detail by order ID
   */
  getCuttingOrderDetail: async (orderId: number): Promise<any> => {
    const response = await client.get(`/cutting-orders/${orderId}`);
    return response.data;
  },

  /**
   * Get action history for an order item
   */
  getActionHistory: async (itemId: number): Promise<ActionHistoryItem[]> => {
    const response = await client.get(`/cutting-orders/item/${itemId}/history`);
    return response.data;
  },

  /**
   * Perform action on order item
   * @param itemId - Order item ID
   * @param type - Action type: 6 = Item Cut (Machine Cut), 10 = Hand Cut, 11 = Pull from Stock
   * @param createBy - Optional username who created the action
   */
  performAction: async (
    itemId: number,
    type: 6 | 10 | 11,
    createBy?: string
  ): Promise<{ success: boolean; message: string }> => {
    const response = await client.post(`/cutting-orders/item/${itemId}/action`, {
      type,
      createBy
    });
    return response.data;
  },

  /**
   * Get cutting print data for generating traveler
   */
  getCuttingPrintData: async (
    itemId: number,
    type?: number,
    binNumber?: string
  ): Promise<any> => {
    const params = new URLSearchParams();
    if (type) params.append('type', type.toString());
    if (binNumber) params.append('binNumber', binNumber);

    const response = await client.get(
      `/cutting-orders/item/${itemId}/print?${params.toString()}`
    );
    return response.data;
  }
};
